import { X, ExternalLink, Info, Zap, Gift, AlertTriangle } from 'lucide-react';

const TYPE_STYLES = {
  info:         { icon: Info,          bg: 'bg-sky-600/90',    text: 'text-sky-50' },
  beta_update:  { icon: Zap,           bg: 'bg-purple-600/90', text: 'text-purple-50' },
  promo:        { icon: Gift,          bg: 'bg-emerald-600/90',text: 'text-emerald-50' },
  warning:      { icon: AlertTriangle, bg: 'bg-amber-600/90',  text: 'text-amber-50' },
};

export function AnnouncementBanner({ announcement, onDismiss, position = 'top' }) {
  const { announcement_id, title, message, cta_text, cta_link, announcement_type } = announcement;
  const style = TYPE_STYLES[announcement_type] || TYPE_STYLES.info;
  const Icon = style.icon;

  const posClass = position === 'top' ? 'top-0' : 'bottom-0';

  return (
    <div
      className={`fixed ${posClass} left-0 right-0 z-[9998] ${style.bg} backdrop-blur-md shadow-lg animate-in slide-in-from-${position === 'top' ? 'top' : 'bottom'} duration-300`}
      data-testid={`announcement-banner-${announcement_id}`}
    >
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
        <Icon className={`w-5 h-5 ${style.text} flex-shrink-0`} />
        <div className="flex-1 min-w-0">
          <span className={`text-sm font-semibold ${style.text}`}>{title}</span>
          {message && <span className={`text-sm ${style.text} opacity-80 ml-2 hidden sm:inline`}>&mdash; {message.length > 100 ? message.substring(0, 100) + '...' : message}</span>}
        </div>
        {cta_text && cta_link && (
          <a
            href={cta_link}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-xs font-semibold ${style.text} underline underline-offset-2 flex items-center gap-1 flex-shrink-0`}
            data-testid="banner-cta"
          >
            {cta_text}
            <ExternalLink className="w-3 h-3" />
          </a>
        )}
        <button
          onClick={() => onDismiss(announcement_id)}
          className={`w-7 h-7 rounded-full flex items-center justify-center ${style.text} opacity-60 hover:opacity-100 hover:bg-muted/60 transition flex-shrink-0`}
          data-testid="banner-close-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
